var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{class:!_vm.bMini ? 'viewLayoutWrapper MiniPadding':'viewLayoutWrapper',attrs:{"column":"","justify-start":""}},[_c('detail-category')],1)}
var staticRenderFns = []

export { render, staticRenderFns }